import clsx from 'clsx';
import { OTPInput, type SlotProps } from 'input-otp';
import * as React from 'react';

import styles from './MFACodeInput.module.css';

/**
 * Text input for a multi-factor authentication code.
 */
export function MFACodeInput(props: {
    disabled?: boolean;
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
}) {
    const { disabled, value, onChange, onSubmit } = props;

    const ref = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        ref.current?.focus();
    }, []);

    return (
        <OTPInput
            ref={ref}
            disabled={disabled}
            maxLength={6}
            value={value}
            onChange={onChange}
            onComplete={() => onSubmit()}
            containerClassName={styles.mfaInput}
            render={({ slots }) => (
                <>
                    <div className={styles.mfaInputSection}>
                        {slots.slice(0, 3).map((slot, idx) => (
                            <Slot key={idx} {...slot} />
                        ))}
                    </div>

                    <div className={clsx('mx-3 text-ui-heading-large', styles.mfaFakeDash)}>
                        {'-'}
                    </div>

                    <div className={styles.mfaInputSection}>
                        {slots.slice(3).map((slot, idx) => (
                            <Slot key={idx} {...slot} />
                        ))}
                    </div>
                </>
            )}
        />
    );
}

function Slot(props: SlotProps) {
    return (
        <div
            className={clsx(
                'flex items-center justify-center text-ui-heading-large',
                styles.mfaInputSlot,
                props.isActive && styles.mfaInputSlotActive
            )}
        >
            {props.char !== null ? <div>{props.char}</div> : null}
        </div>
    );
}
